import React from 'react';
//Imports Context
import staticData from '../../../contexts/staticData.json';
//Import Helpers
import { formatCurrency, formatDate, formatDisplayName } from "../../../shared/helpers";
//Import Icons
import info from '../../../assets/icons/info.svg';
//Import CSS
import './requestHistoryItem.css';

const RequestHistoryItem = ({ historyItem, requestDetails, responseView = false, isPaymentRequest, hasActivePO }) => {
    const {
        details,
        sentTo,
        timestamp,
        responsibleName,
        role,
        action,
        amount,
        responseRequest,
        backups,
        response,
        amountToBePaid,
        purchaseOrderAmount
    } = historyItem;

    const {
        attachments,
        observations,
        requestAmount,
        technicalJustification
        // amountToBePaid
    } = requestDetails;

    const getAllAttachments = () => {
        if (!attachments) return [];

        return Object.values(attachments).flat().map(attachment => ({
            fileName: attachment.fileName,
            fileUrl: attachment.fileUrl
        }));
    };

    const allAttachments = getAllAttachments();

    const responseMapping = {
        approved: 'Aprobado',
        rejected: 'Rechazado',
        observed: 'Observada'
    };
    
    const renderBackups = (backups) => {
        if (!backups || (Array.isArray(backups) && backups.length === 0) || (typeof backups === 'object' && Object.keys(backups).length === 0)) {
            return null;
        }

        // Función auxiliar para extraer archivos independientemente de su estructura
        const extractFiles = (data) => {
            if (Array.isArray(data)) {
                return data;
            }

            // Si es un objeto, extraemos todos los archivos sin importar la carpeta
            return Object.values(data).reduce((files, item) => {
                if (Array.isArray(item)) {
                    return [...files, ...item];
                }
                if (item.fileName || item.fileUrl) {
                    return [...files, item];
                }
                return files;
            }, []);
        };

        const files = extractFiles(backups);

        if (files.length === 0) return null;

        return (
            <section className="history-item-attachments flex">
                <p><strong>Documentos adjuntos:</strong></p>
                <ul className='flex'>
                    {files.map((file, index) => (
                        <li key={index} className='document flex'>
                            <a href={file.fileUrl || file.url} target="_blank" rel="noopener noreferrer">
                                {file.fileName || file.name || 'Archivo adjunto'}
                            </a>
                        </li>
                    ))}
                </ul>
            </section>
        );
    };

    const renderActionSpecificContent = () => {
        if (isPaymentRequest) {
            return (
                <>
                    {amountToBePaid && <p><strong>Monto a pagar:</strong> {formatCurrency(amountToBePaid)}</p>}
                    {renderBackups(backups)}
                </>
            );
        } else if (action === 'Solicitud de compra creada') {
            return (
                <>
                    {requestDetails.observations && <p><strong>Observaciones:</strong> {requestDetails.observations}</p>}
                    {requestDetails.technicalJustification && <p><strong>Justificación técnica:</strong> {requestDetails.technicalJustification}</p>}
                    {renderBackups(requestDetails.attachments)}
                </>
            );
        } else {
            return (
                <>
                    <p><strong>Respuesta:</strong> {responseMapping[responseRequest] || 'Desconocido'}</p>
                    {renderBackups(backups)}
                </>
            );
        }
    };
    return (
        <>
            <article className={`history-item flex ${responseRequest === 'observed' ? 'response-observed' : responseRequest === 'rejected' ? 'response-rejected' : ''}`}>
                <header className={`history-item-header flex ${responseRequest === 'observed' ? 'response-observed' : responseRequest === 'rejected' ? 'response-rejected' : ''} ${responseView ? 'response' : ''}`}>
                    <span className='span-header flex'>
                        {(responseRequest === 'observed' || responseRequest === 'rejected' || responseView) && (
                            <img
                                src={info}
                                className='icon'
                                alt='icono de solicitud observada'
                            />
                        )}
                        <span>{formatDate(timestamp)} {formatDisplayName(responsibleName)} ({role}) - <strong>{action}</strong></span>
                    </span>
                    <span><strong>
                        {(hasActivePO || purchaseOrderAmount) ? 'Monto O.C / Contrato: ' : 'Monto solicitud: '}
                        {formatCurrency((isPaymentRequest && amountToBePaid)
                            ? amountToBePaid
                            : ((hasActivePO || purchaseOrderAmount) ? (purchaseOrderAmount || requestDetails.purchaseOrderAmount) : (amount || requestAmount)))}
                    </strong></span>
                </header>
                <section className={`history-item-details flex ${responseView ? 'response' : ''}`}>
                    <p>{details}</p>
                    <p><strong>Enviado a:</strong> {sentTo}</p>
                    {renderActionSpecificContent()}
                </section>
            </article>
            {(response && response.length > 0) && (
                response.map((responseItem, index) => (
                    <RequestHistoryItem
                        key={index}
                        historyItem={responseItem}
                        requestDetails={requestDetails}
                        isPaymentRequest={isPaymentRequest}
                        responseView={true}
                    />
                ))

            )}

        </>
    );
};

export default RequestHistoryItem;
